:host {
  display: block;
}

.phone-zip-error-text {
  /* colors */
  color: var(--clrs-subtext-label-error);

  @apply basis-full text-xs pl-4;
}
